import * as yup from 'yup'

export const validationSchema = () => yup.object({
    email: yup.string().required("Campo obbligatorio").matches(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, "Email invalida"),
})